// merges two objects, the right one can override the left one

interface IBaseObject {
	[key: string]: unknown;
}

interface IMergeObjects<T extends IBaseObject, Z = Partial<T>> {
	(obj1: T, obj2: Z): { [Property in keyof T & Z]: (T & Z)[Property] };
}

const mergeObjects: IMergeObjects<IBaseObject> = (existing, newObject) => {
	if (!newObject) {
		return existing;
	}

	const newEntries = Object.entries(newObject);

	return newEntries.reduce((acc, [key, value]) => {
		if (value && existing[key] && typeof value === 'object') {
			if (Array.isArray(value)) {
				return { ...acc, [key]: value };
			}

			return { ...acc, [key]: mergeObjects(existing[key] as IBaseObject, value) };
		}

		return { ...acc, [key]: value };
	}, existing);
};

export default mergeObjects;
